module.exports = function() {
  return new Worker(__webpack_public_path__ + "0a565011687e97346f2d.worker.js");
};